import { extendTheme } from '@chakra-ui/react';
import { StepsTheme as Steps } from 'chakra-ui-steps';

const theme = extendTheme({
  styles: {
    global: {
      body: {
        backgroundColor: '#F6F6F6',
        color: 'gray.800',
        // margin: 0,
        minHeight: '100vh',
        marginBottom: '70px',
      },
    },
  },
  components: {
    Steps,
  },
});

export default theme;

export const CommonColors = {
  placeholder: 'gray.300',
  checkbox: { on: 'blue.500', off: 'transparent' },
  errorMessages: 'red.500',
};
